// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"415":"da6e4550","444":"3903c0cb","484":"005a171b","529":"cf6b4016","548":"b9fa2edc","551":"eebf1ec6","706":"22a7d981","888":"7bf1239c","909":"472fa2fa","950":"fc47bf65","979":"58cd8465"}[chunkId] + ".chunk.js";
};